// extracted by mini-css-extract-plugin
export default {"identifier":"Vouchers_identifier__8PeMU"};